function showContent(event, contentId) {
  // 隐藏所有内容
  const contents = document.querySelectorAll('.content');
  contents.forEach(content => content.classList.remove('active'));

  // 移除所有标签的激活状态
  const tabs = document.querySelectorAll('.tab');
  tabs.forEach(tab => tab.classList.remove('active'));

  // 显示当前选中的内容
  document.getElementById(contentId).classList.add('active');

  // 设置当前标签为激活状态
  event.currentTarget.className += " active";
}